import {basePathApi} from './basePathApi';
export const baseUrl = basePathApi+'api/'
// export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api/' : 'http://localhost:8000/api/'
